import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'iposcen-send-to-retailer-popup',
  templateUrl: './send-to-retailer-popup.component.html',
  styleUrls: ['./send-to-retailer-popup.component.scss']
})
export class SendToRetailerPopupComponent implements OnInit {
  @Input() contentName: string;
  @Input() buttonName: string;
  @Input() description: string;
  @Input() heroTileSuccess: string;
  @Input() heroTileSuccessInfo: string;
  isSendHeroTile: boolean;
  @Output() readonly delete = new EventEmitter();
  @Output() readonly sendHeroTile = new EventEmitter();
  @ViewChild('sendToRetailerModal') private modalContent: TemplateRef<SendToRetailerPopupComponent>;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private modalService: NgbModal,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.isSendHeroTile = false;
    this.cmnService.emitSendHeroTileStatusObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.isSendHeroTile = true;
      });
    
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
    this.isSendHeroTile = false;
  }

  dismiss() {
    this.modalRef.dismiss();
    this.isSendHeroTile = false;
  }

  sendToRetailerHq() {
    this.sendHeroTile.emit();
    this.cmnService.emitRefreshHeroTileData(true);
  }
}
